module.exports = __webpack_public_path__ + "img/5-5.846d9571.svg";